import { Inline } from '../../../design-system/inline/inline';
import { LoadingSpinner } from '../../../design-system/loading/loading-spinner';
import { Stack } from '../../../design-system/stack/stack';

export const PayeeCheckLoadingCard = () => {
  return (
    <Inline
      space={3}
      align="start"
      wrap="nowrap"
      className="rounded-card border-[0.5px] border-seapoint-gray-border bg-white px-4 py-3"
    >
      <LoadingSpinner className="h-7 w-7 shrink-0" />

      <Stack space={1}>
        <h3 className="text-base font-semibold leading-5 tracking-tight text-black">Checking details</h3>

        <p className="text-sm font-medium leading-5 tracking-tight text-seapoint-gray-text">
          For additional security we're checking the details you provided with the recipient's bank.
        </p>
      </Stack>
    </Inline>
  );
};
